export const BUSINESS_BENEFIT_UPGRADE_PLUS_CODE = 'E4B_REWARD_PLUS';
export const BUSINESS_BENEFIT_UPGRADE_PREMIER_CODE = 'E4B_REWARD_PREMIER';
export const BUSINESS_BENEFIT_RED_UPGRADE_PLUS_CODE = 'RED_E4B_REWARD_PLUS';
export const BUSINESS_BENEFIT_RED_UPGRADE_PREMIER_CODE = 'RED_E4B_REWARD_PREMI';
export const BUSINESS_BENEFIT_PLUS_CODES = [BUSINESS_BENEFIT_UPGRADE_PLUS_CODE, BUSINESS_BENEFIT_RED_UPGRADE_PLUS_CODE];
export const BUSINESS_BENEFIT_PREMIER_CODES = [BUSINESS_BENEFIT_UPGRADE_PREMIER_CODE, BUSINESS_BENEFIT_RED_UPGRADE_PREMIER_CODE];
export const BUSINESS_BENEFIT_UPGRADE_CODES = [
  BUSINESS_BENEFIT_UPGRADE_PLUS_CODE,
  BUSINESS_BENEFIT_UPGRADE_PREMIER_CODE,
  BUSINESS_BENEFIT_RED_UPGRADE_PLUS_CODE,
  BUSINESS_BENEFIT_RED_UPGRADE_PREMIER_CODE
];
export const BUSINESS_BENEFIT_STATUS_USED = 'Used';
